const normalizeDomain = (value = '') => {
  if (!value) return '';

  let normalized = String(value).trim().toLowerCase();
  if (!normalized) return '';

  if (normalized.startsWith('@')) {
    normalized = normalized.slice(1);
  }

  if (normalized.startsWith('www.')) {
    normalized = normalized.slice(4);
  }

  // Remove port if present.
  if (normalized.includes(':')) {
    normalized = normalized.split(':')[0];
  }

  return normalized;
};

export const extractDomainFromEmail = (email = '') => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  if (!normalizedEmail.includes('@')) return '';

  const parts = normalizedEmail.split('@');
  return normalizeDomain(parts[parts.length - 1]);
};

export const extractDomainFromWebsite = (website = '') => {
  const raw = String(website || '').trim();
  if (!raw) return '';

  let candidate = raw;
  if (!/^https?:\/\//i.test(candidate)) {
    candidate = `https://${candidate}`;
  }

  try {
    const url = new URL(candidate);
    return normalizeDomain(url.hostname);
  } catch {
    const host = raw.replace(/^https?:\/\//i, '').split('/')[0];
    return normalizeDomain(host);
  }
};

export const resolveCompanyDomain = ({ companyWebsite, companyEmail, userEmail } = {}) =>
  extractDomainFromWebsite(companyWebsite) ||
  extractDomainFromEmail(companyEmail) ||
  extractDomainFromEmail(userEmail) ||
  '';

export const isEmailInCompanyDomain = (email = '', companyDomain = '') => {
  const allowedDomain = normalizeDomain(companyDomain);
  if (!allowedDomain) return true;

  const emailDomain = extractDomainFromEmail(email);
  return !!emailDomain && emailDomain === allowedDomain;
};

